import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityPT extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Declaração de Acessibilidade - CamAPS FX</title>
                    <meta name="title" content="Declaração de Acessibilidade"/>
                    <meta name="description"
                          content="A CamDiab está empenhada em facilitar e melhorar a acessibilidade e a usabilidade dos seus produtos digitais para todas as pessoas, incluindo pessoas com defici"/>
                    <meta property="og:locale" content="pt"/>
                    <meta name="keywords" content="declaração de acessibilidade"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Declaração de Acessibilidade</h1>
                                <h3>Versão datada de 11 de setembro de 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    A CamDiab está empenhada em facilitar e melhorar a acessibilidade e a usabilidade dos seus produtos digitais para todas as pessoas, incluindo pessoas com deficiência.
                                </p>
                                <h2>
                                    Estado de conformidade
                                </h2>
                                <p>
                                    A CamDiab pretende alcançar a conformidade com as Diretrizes de Acessibilidade para Conteúdo Web (WCAG), versão 2.2, nível AA (WCAG 2.2 AA). Estas diretrizes, reconhecidas mundialmente, ajudam a tornar os conteúdos Web mais acessíveis a todos.
                                </p>
                                <h2>
                                    Medidas adicionais de apoio à acessibilidade
                                </h2>
                                <p>
                                    A CamDiab está a tomar, entre outras, as seguintes medidas adicionais para tornar os nossos conteúdos digitais mais fáceis de utilizar:
                                </p>
                                <ul>
                                    <li>Proporcionar formação contínua sobre acessibilidade aos nossos colaboradores</li>
                                    <li>Utilizar métodos formais de garantia da qualidade da acessibilidade através de avaliações realizadas por terceiros</li>
                                    <li>Definir objetivos e responsabilidades claros em matéria de acessibilidade</li>
                                </ul>
                                <h2>
                                    Feedback
                                </h2>
                                <p>
                                    Agradecemos comentários sobre como podemos melhorar os nossos produtos digitais para utilizadores com deficiência. Se tiver dificuldades em visualizar ou navegar pelos nossos conteúdos, ou se identificar algum conteúdo, recurso ou funcionalidade que considere não ser totalmente acessível a pessoas com deficiência, contacte-nos através do nosso endereço de e-mail de suporte: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Levamos o seu feedback a sério e iremos tê-lo em consideração ao avaliarmos formas de responder às necessidades de todos os nossos clientes e as nossas políticas gerais de acessibilidade. Além disso, embora não controlemos os conteúdos fornecidos por terceiros, incentivamo-los vivamente a disponibilizar conteúdos acessíveis e fáceis de utilizar.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
